// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../../bs-utils/src/ArrayUtils.bs.js");
var DOM__Shadow$SmartcutsMacros = require("../../DOM__Shadow.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../bs-utils/src/OptionUtils.bs.js");
var DOM__Element$SmartcutsMacros = require("../../DOM__Element.bs.js");

function getWindowForElement(htmlElement) {
  var arg = Webapi__Dom__Document.asHtmlDocument(htmlElement.ownerDocument);
  return Caml_option.nullable_to_opt((function (param) {
                  return OptionUtils$SmartcutsMacros.getExn(param, arg);
                })("Expected html document").defaultView);
}

function simulateBlurEvent(htmlElement) {
  var $$window = getWindowForElement(htmlElement);
  var blurEvent = new FocusEvent("blur", {
        bubbles: false,
        cancelable: true,
        view: $$window,
        relatedTarget: null
      });
  var focusOutEvent = new FocusEvent("focusout", {
        bubbles: true,
        cancelable: true,
        view: $$window,
        relatedTarget: null
      });
  htmlElement.dispatchEvent(blurEvent);
  htmlElement.dispatchEvent(focusOutEvent);
  
}

function fireBlur(htmlElement) {
  htmlElement.blur();
  return simulateBlurEvent(htmlElement);
}

function simulateFocusEvent(htmlElement) {
  var $$window = getWindowForElement(htmlElement);
  var focusEvent = new FocusEvent("focus", {
        bubbles: false,
        cancelable: true,
        view: $$window
      });
  var focusInEvent = new FocusEvent("focusin", {
        bubbles: true,
        cancelable: true,
        view: $$window
      });
  htmlElement.dispatchEvent(focusEvent);
  htmlElement.dispatchEvent(focusInEvent);
  
}

function fireFocus(htmlElement) {
  var activeElement = DOM__Shadow$SmartcutsMacros.getActiveHtmlElementForDocument(undefined);
  if (activeElement !== undefined) {
    fireBlur(Caml_option.valFromOption(activeElement));
  }
  return simulateFocusEvent(htmlElement);
}

function focusOnElement(elementToFocus) {
  var tagName = elementToFocus.tagName;
  if (tagName === "INPUT" || tagName === "TEXTAREA") {
    elementToFocus.focus();
    return ;
  } else {
    DOM__Element$SmartcutsMacros.isContentEditable(elementToFocus);
    return fireFocus(elementToFocus);
  }
}

function tabIndexStringToTabIndexInt(tabIndex) {
  if (tabIndex === "") {
    return 0;
  } else {
    return Caml_format.caml_int_of_string(tabIndex);
  }
}

function hasNaturalFocusCapability(element) {
  var tagName = element.tagName;
  if (tagName === "INPUT" || tagName === "TEXTAREA") {
    return true;
  } else {
    return DOM__Element$SmartcutsMacros.isContentEditable(element);
  }
}

function maybeDispatchFocusEvents(element) {
  var tagName = element.tagName;
  if (tagName === "INPUT" || tagName === "TEXTAREA" || DOM__Element$SmartcutsMacros.isContentEditable(element) || element.hasAttribute("tabindex")) {
    return focusOnElement(element);
  }
  var descendantsWithTabIndex = Belt_Array.keepMap(Array.prototype.slice.call(element.querySelectorAll("[tabIndex]")), Webapi__Dom__Element.ofNode);
  var visibleDescendantsWithTabIndex = Belt_Array.keep(descendantsWithTabIndex, DOM__Element$SmartcutsMacros.isVisibleOnPage);
  var visibleDescendantsWithNonNegativeTabIndex = Belt_Array.keep(visibleDescendantsWithTabIndex, (function (el) {
          var arg = el.getAttribute("tabIndex");
          var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
          var maybeTabIndex = (function (param) {
                return OptionUtils$SmartcutsMacros.orElse(param, arg$1);
              })(Caml_option.nullable_to_opt(el.getAttribute("tabindex")));
          if (maybeTabIndex === "-1") {
            return false;
          } else {
            return true;
          }
        }));
  var orderedVisibleDescendantsWithNonNegativeTabIndex = ArrayUtils$SmartcutsMacros.sort((function (elA, elB) {
          var arg = elA.getAttribute("tabIndex");
          var arg$1 = (arg == null) ? undefined : Caml_option.some(arg);
          var match = OptionUtils$SmartcutsMacros.map((function (param) {
                    return OptionUtils$SmartcutsMacros.orElse(param, arg$1);
                  })(Caml_option.nullable_to_opt(elA.getAttribute("tabindex"))), tabIndexStringToTabIndexInt);
          var arg$2 = elB.getAttribute("tabIndex");
          var arg$3 = (arg$2 == null) ? undefined : Caml_option.some(arg$2);
          var match$1 = OptionUtils$SmartcutsMacros.map((function (param) {
                    return OptionUtils$SmartcutsMacros.orElse(param, arg$3);
                  })(Caml_option.nullable_to_opt(elA.getAttribute("tabindex"))), tabIndexStringToTabIndexInt);
          if (match === undefined) {
            return 0;
          }
          var exit = 0;
          if (match !== 0 || match$1 === undefined) {
            exit = 1;
          } else {
            if (match$1 > 0) {
              return 1;
            }
            exit = 1;
          }
          if (exit === 1) {
            if (match$1 === undefined) {
              return 0;
            }
            var exit$1 = 0;
            if (match$1 !== 0) {
              exit$1 = 2;
            } else {
              if (match > 0) {
                return -1;
              }
              exit$1 = 2;
            }
            if (exit$1 === 2) {
              if (match !== match$1) {
                return match - match$1 | 0;
              }
              var match$2 = hasNaturalFocusCapability(elA);
              var match$3 = hasNaturalFocusCapability(elB);
              if (!match$2) {
                if (match$3) {
                  return 1;
                } else {
                  return 0;
                }
              }
              if (!match$3) {
                return -1;
              }
              var match$4 = DOM__Element$SmartcutsMacros.isVisibleInViewport(elA);
              var match$5 = DOM__Element$SmartcutsMacros.isVisibleInViewport(elB);
              if (match$4) {
                if (match$5) {
                  return 0;
                } else {
                  return -1;
                }
              } else if (match$5) {
                return 1;
              } else {
                return 0;
              }
            }
            
          }
          
        }), visibleDescendantsWithNonNegativeTabIndex);
  var descendantToFocus = Belt_Array.get(orderedVisibleDescendantsWithNonNegativeTabIndex, 0);
  if (descendantToFocus !== undefined) {
    return focusOnElement(Caml_option.valFromOption(descendantToFocus));
  }
  
}

exports.getWindowForElement = getWindowForElement;
exports.simulateBlurEvent = simulateBlurEvent;
exports.fireBlur = fireBlur;
exports.simulateFocusEvent = simulateFocusEvent;
exports.fireFocus = fireFocus;
exports.maybeDispatchFocusEvents = maybeDispatchFocusEvents;
/* Webapi__Dom__Element Not a pure module */
